import { render, staticRenderFns } from "./AutoCompleteResultUser.vue?vue&type=template&id=8b45c5ec"
import script from "./AutoCompleteResultUser.vue?vue&type=script&lang=js"
export * from "./AutoCompleteResultUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports